import React from 'react';
import { motion } from 'framer-motion';
import { FaDownload, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const DataMarketplace = () => {
  const navigate = useNavigate();

  const datasets = [
    {
      id: 1,
      title: "Multilingual Text Classification Dataset",
      description: "High-quality synthetic text data for multilingual classification tasks",
      category: "text",
      size: "1.2GB",
      downloads: 245,
      price: "$49.99",
      rating: 4.8
    },
    {
      id: 2,
      title: "Financial Time Series Data",
      description: "Synthetic financial data for predictive modeling and analysis",
      category: "numerical",
      size: "850MB",
      downloads: 189,
      price: "$79.99",
      rating: 4.6
    },
    {
      id: 3,
      title: "Medical Imaging Dataset",
      description: "Expert-reviewed synthetic medical images for AI training",
      category: "image",
      size: "2.5GB",
      downloads: 156,
      price: "$129.99",
      rating: 4.9
    }
  ];

  const handleSubmitDataset = () => {
    navigate("/submit-dataset");
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-blue-600 mb-8">
            Data Marketplace
          </h1>
          <div className="flex justify-center mb-8">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleSubmitDataset}
              className="bg-blue-600 text-white px-6 py-3 rounded-lg flex items-center gap-2 hover:bg-blue-700 transition-colors"
            >
              <FaPlus />
              Submit Dataset
            </motion.button>
          </div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Browse and purchase high-quality synthetic datasets for your AI projects
          </p>
        </div>

        {/* Dataset Grid */}
        {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {datasets.map((dataset) => (
            <motion.div
              key={dataset.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.02 }}
              className="bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden h-full flex flex-col"
            >
              <div className="p-6 flex flex-col h-full">
                <div className="flex justify-between items-start mb-4">
                  <h3 className="text-xl font-semibold text-blue-600">{dataset.title}</h3>
                  <span className="px-3 py-1 bg-blue-100 text-blue-600 rounded-full text-sm">
                    {dataset.category}
                  </span>
                </div>
                <p className="text-gray-600 mb-4 flex-grow">{dataset.description}</p>
                <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                  <span>{dataset.size}</span>
                  <span>{dataset.downloads} downloads</span>
                  <span>⭐ {dataset.rating}</span>
                </div>
                <div className="flex items-center justify-between mt-auto">
                  <span className="text-2xl font-bold text-blue-600">{dataset.price}</span>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors duration-300"
                  >
                    <FaDownload />
                    Purchase
                  </motion.button>
                </div>
              </div>
            </motion.div>
          ))}
        </div> */}
      </div>
    </div>
  );
};

export default DataMarketplace; 